import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SignMergersAcquisitionsContract from "./SignMergersAcquisitionsContract";
import { Tooltip } from "react-tooltip";
import {
  getMemberSince,
  today,
} from "../../../../Common/AllDateTimeReleventFormate";
import ClientUserCommonDetails from "../../../../Common/ClientUserCommonDetails";
import ContractView from "../../../../CustomComponents/ContractView";
import { getMergerById } from "../../../../../redux/mergers/action";
import { penaltytips } from "../../../../Common/Tooltips/tooltip";


export default function MergersAcquisitionsContract() {
  const path = "Assets/scss/FindWork.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();

  const { id } = useParams();
  const pbi = useSelector(({ mergers: { getmergersbyid } }) => getmergersbyid);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMergerById(id));
  }, [id]);

  return (
    <div className="container-fluid contract">
      <div className="project-offer project-details col-lg-10 mx-auto">
        <p className="breadcrumbs">
          <a onClick={() => navigate(`/${lan}/searchmergersacquisitions`)}>MAS &gt; </a>
          <a onClick={() => navigate(-1)}>{pbi?.title || pbi?.company_name || "All proposal"} &gt;</a> Contract
        </p>
        <div id='take-screenshot-for-this-form' className="col-lg-10 mx-auto">
          <div className="contract-sec" id="capture-contract-section">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/project/contract-logo.svg`}
              alt=""
            />
            <div className="flex-sec">
              <p>Date : {getMemberSince(today)}</p>
              <p>ID : {pbi?.id}</p>
            </div>
            <div className="website-design">
              <ContractView type={'merger_agreement'} />
            </div>
            <ClientUserCommonDetails pbi={pbi} />
            <SignMergersAcquisitionsContract pbi={pbi} />
          </div>
        </div>
      </div>
      <Tooltip
        id="my-tooltip-1"
        place="bottom"
        content={penaltytips}
      />
    </div>
  );
}
